import { AfterViewInit, Component, ElementRef, Input, LOCALE_ID, NgZone } from '@angular/core'
import { CommonModule } from '@angular/common'
import { RouterModule } from '@angular/router'
import { Rumour } from '../../../../../../core/models/rumour.model';
import { NewsService } from '../../../../services/news.service';
import { AutoscaleTextDirective } from 'src/app/shared/directives/autoscale-text.directive';
import { AutoscaleTextRumorDirective } from 'src/app/shared/directives/autoscale-text-rumor.directive';

@Component({
  selector: 'rumores-card',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    AutoscaleTextRumorDirective
  ],
  templateUrl: 'rumores-card.component.html',
  styleUrl: 'rumores-card.component.css'
})
export class RumoresCard implements AfterViewInit{
  @Input() rumor: Rumour | null = null
  isCompact = false

  constructor(
    public service: NewsService,
    private elementRef: ElementRef,
    private zone: NgZone
  ) {}
  
  ngAfterViewInit() {
    const card = this.elementRef.nativeElement.querySelector('.quote-card')
    const observer = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.zone.run(() => {
          this.isCompact = (entry.target as HTMLElement).offsetWidth < 570
        })
      }
    })
    observer.observe(card)
  }

  getOldestAuthor(newsArray: any[]): string {
    if (!newsArray.length) return ''

    let oldestNews = newsArray.reduce((oldest, current) => {
      const oldestDate = new Date(oldest.date).getTime()
      const currentDate = new Date(current.date).getTime()
      return currentDate < oldestDate ? current : oldest
    })

    return oldestNews.source || ''
  }

  getNewestAuthor(newsArray: any[]): string {
    if (!newsArray.length) return ''

    let oldestNews = newsArray.reduce((oldest, current) => {
      const oldestDate = new Date(oldest.date).getTime()
      const currentDate = new Date(current.date).getTime()
      return currentDate > oldestDate ? current : oldest
    })

    return oldestNews.source || ''
  }
}